module.exports = __webpack_public_path__ + "img/article2-1.87945a96.png";